import { TemplateGallery } from '@/components/experiences/template-gallery';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Plus } from 'lucide-react';

export function NewExperienceDialog({ compact = false }: { compact?: boolean }): React.JSX.Element {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size={compact ? 'sm' : 'default'}>
          <Plus className="size-4" />
          New experience
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] max-w-6xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Start an experience</DialogTitle>
          <DialogDescription>Choose the outcome, then start from a recommended template or a blank surface.</DialogDescription>
        </DialogHeader>
        <TemplateGallery />
      </DialogContent>
    </Dialog>
  );
}
